<template>
  <section class="referral-page-footer__container">
    <div>
      <h3>{{ renderData.title }}</h3>
      <h4>{{ renderData.description }}</h4>
    </div>
    <ul>
      <li 
        v-for="(content,index) in renderData.children"
        :key="'question-'+index"
      >
        <h3>{{ content.title }}</h3>
        <h4>{{ content.description }}</h4>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      renderData: {
        title: '자주 묻는 질문',
        description:
          '궁금한 내용이 없을 경우 헬프센터로 1:1 상담을 요청해 주세요.',
        children: [
          {
            title:
              '지인이 가입만 했거나 무료 플랜을 이용하고 있다면 리워드가 없나요?',
            description:
              '초대받은 지인이 가입 후 유료 플랜으로 전환할 경우에만 1개월 무료 연장 혜택이 제공됩니다. 지인이 가입만 했거나 가입 후 아직 무료 플랜을 이용 중이라면 리워드 제공은 어려운 점 양해 부탁드립니다.'
          },
          {
            title:
              '무료 플랜 이용 중입니다. 지인 초대 프로그램에 참여할 수 있나요?',
            description:
              '본 프로그램은 별도 조건 없이 무제한으로 참여가 가능합니다. 다만 초대받은 지인이 유료 플랜으로 전환하는 시점에 귀하가 무료 플랜을 이용 중이라면 지인에게만 리워드가 선별 제공되고 귀하는 이후 유료 플랜 전환 시에 리워드가 자동 지급될 예정입니다.'
          },
          {
            title:
              '지인이 초대 링크가 아닌 다른 페이지에서 가입 후 결제했다고 합니다. 이 경우 리워드 제공이 안되나요?',
            description:
              '귀하의 초대 링크가 아닌 일반 가입 페이지에서 추천사를 미기재했을 경우 리워드 적용이 불가합니다. 반드시 지인에게 초대 링크 또는 가입 시 귀하의 센터명을 기입할 것을 안내해 주시길 바랍니다.'
          },
          {
            title: '지인 초대를 완료했는데 리워드를 아직 못 받았어요.',
            description:
              '초대받은 지인이 타 프로모션 혜택을 이미 수여했거나 부정한 목적으로 가입 및 이용한 사실이 밝혀질 경우 리워드가 자동 취소되거나 회수될 수 있습니다. 1:1 상담을 요청해 주시면 자세한 내용을 확인해 드리도록 하겠습니다.'
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss">
.referral-page-footer__container {
  margin: 1rem 0;
  display: flex !important;
  flex-wrap: wrap;
  color: #4a4a4a;
  h3,
  h4 {
    word-break: keep-all;
  }
  div:first-child {
    width: 406px;
    margin-right: 20px;
    h3 {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.11;
      letter-spacing: -1.03px;
      margin: 0 0 7px 0;
    }
    h4 {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: -0.8px;
      margin: 0;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }

  ul {
    width: calc(100% - 426px);
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    li {
      h3 {
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -1px;
        margin: 0 0 5px 0;
      }
      h4 {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.87px;
        margin: 0;
      }

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
